import React from 'react';
import { withRouter } from 'react-router';
import qs from 'qs';

import InputField from 'components/InputField';
import SelectField from 'components/SelectField';

class PurchaseLineItemsFilters extends React.Component {
  constructor(props) {
    super(props);
    this.emptyState = {
      simo_subscription: '',
      att_subscription: '',
      mdn: '',
      ordering: '',
      icc_id: '',
    };
    let initState = { ...this.emptyState };
    let showFilters = false;

    for (const key in this.emptyState) {
      if (this.props.qsSearch[key]) {
        initState[key] = this.props.qsSearch[key];
        showFilters = true;
      }
    }

    this.state = {
      ...initState,
      showFilters,
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleReset = () => {
    const {
      history,
      location: { search },
    } = this.props;
    const oldParams = qs.parse(search, { ignoreQueryPrefix: true });
    const {
      simo_subscription,
      att_subscription,
      mdn,
      icc_id,
      ordering,
      lineItemsPage,
      ...newParams
    } = oldParams;

    this.setState(this.emptyState);

    history.push({
      search: qs.stringify(newParams),
    });
  };

  handleApply = () => {
    const {
      history,
      location: { search },
    } = this.props;
    const oldParams = qs.parse(search, { ignoreQueryPrefix: true });
    const { showFilters, ...stateFilters } = this.state;
    const mergedParams = { ...oldParams, ...stateFilters, lineItemsPage: 1 };

    const newParams = Object.entries(mergedParams).reduce((acc, item) => {
      const key = item[0];
      const value = item[1];
      if (value) {
        acc[key] = value;
      }
      return acc;
    }, {});

    if (!this.state.showFilters) {
      this.setState({ showFilters: true });
    }

    history.push({
      search: qs.stringify(newParams),
    });
  };

  render() {
    const { lineItemsCount } = this.props;
    const {
      showFilters,
      att_subscription,
      simo_subscription,
      mdn,
      icc_id,
      ordering,
    } = this.state;
    return (
      (lineItemsCount > 40 || showFilters) && (
        <div className="d-flex">
          <h4 className="w100"> Purchase Items Filters</h4>
          <div className="w-50 pad-r">
            <InputField
              input={{
                value: att_subscription,
                onChange: this.handleChange,
                name: 'att_subscription',
              }}
              label={'ATT Subscription ID'}
              meta={{}}
            />
          </div>
          <div className="w-50 pad-l">
            <InputField
              input={{
                value: simo_subscription,
                onChange: this.handleChange,
                name: 'simo_subscription',
              }}
              label={'Simo Subscription ID'}
              meta={{}}
            />
          </div>
          <div className="w-50 pad-r">
            <InputField
              input={{
                value: icc_id,
                onChange: this.handleChange,
                name: 'icc_id',
              }}
              label={'ICC ID'}
              meta={{}}
            />
          </div>
          <div className="w-50 pad-l">
            <InputField
              input={{
                value: mdn,
                onChange: this.handleChange,
                name: 'mdn',
              }}
              label={'MDN'}
              meta={{}}
            />
          </div>
          <div className="w-50 pad-r">
            <SelectField
              label="Description Ordering"
              input={{
                value: ordering,
                onChange: this.handleChange,
                name: 'ordering',
              }}
              options={[
                ['', '-'],
                ['-description', 'Descending'],
                ['description', 'Ascending'],
              ]}
              meta={{}}
            />
          </div>
          <div
            style={{ marginTop: '10px' }}
            className="w-50 flex-align-center pad-l"
          >
            <button
              className="btn btn-primary mar-r"
              onClick={this.handleApply}
            >
              Apply filters
            </button>
            <button
              className="btn btn-default mal-l"
              onClick={this.handleReset}
            >
              Reset filters
            </button>
          </div>
        </div>
      )
    );
  }
}

export default withRouter(PurchaseLineItemsFilters);
